module.exports = __webpack_public_path__ + "img/Fond-tarifs - Copie.528eb6fa.jpg";